import styled from 'styled-components';

export const FooterWrapper = styled.div`
  padding: 25px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
`;
